import { parse } from '../Utils/numeriHelper';

export const ValidationLevel = {
  ERROR: 'error',
  WARNING: 'warning',
};

const rules = {};

const Validation = {
  register(name, func, params) {
    rules[name] = { ...params, rule: func };
  },

  validate(name, value, additionalParams) {
    if (!rules[name]) {
      throw new Error(`Funzione di validazione ${name} sconosciuta`);
    }
    const params = {};
    for (const prop in rules[name]) {
      if (Object.prototype.hasOwnProperty.call(rules[name], prop)) {
        params[prop] = rules[name][prop];
      }
    }
    if (additionalParams !== undefined) {
      for (const prop in additionalParams) {
        if (Object.prototype.hasOwnProperty.call(additionalParams, prop)) {
          params[prop] = additionalParams[prop];
        }
      }
    }
    const res = rules[name].rule(value, params);
    if (res) { return params.message; }
    return null;
  },

  getValidationLevel(level) {
    if (!level || level === ValidationLevel.ERROR) { return ValidationLevel.ERROR; }
    if (level === ValidationLevel.WARNING) { return ValidationLevel.WARNING; }
    throw new TypeError(`Validation level '${level}' non riconosciuto`);
  },

  validateAll(rulesToVal, value) {
    const messages = [];
    const warnings = [];
    if (rulesToVal) {
      let i = 0;
      for (i = 0; i < rulesToVal.length; i += 1) {
        let message = null;
        let level = ValidationLevel.ERROR;
        const ruleToVal = rulesToVal[i];
        if (typeof (ruleToVal) === 'string') {
          message = Validation.validate(ruleToVal, value);
          level = Validation.getValidationLevel(rules[ruleToVal].level);
        } else if (typeof (ruleToVal) === 'function') {
          const result = ruleToVal(value);
          if (typeof (result) === 'string' || !result) {
            message = result;
          } else {
            // se la funzione ritorna un oggetto controllo se presente l'attributo warning
            const { message: messageResult, level: levelResult } = result;
            message = messageResult;
            level = Validation.getValidationLevel(levelResult);
          }
        } else {
          message = Validation.validate(ruleToVal.rule, value, ruleToVal);
          level = ruleToVal.level
            ? Validation.getValidationLevel(ruleToVal.level)
            : Validation.getValidationLevel(rules[ruleToVal.rule].level);
        }
        if (message != null) {
          if (level === ValidationLevel.WARNING) {
            warnings.push(message);
          } else {
            messages.push(message);
          }
        }
      }
    }
    return {
      valid: messages.length === 0,
      messages,
      warnings,
    };
  },
};

export const codiceFiscaleValido = (value) => {
  // se vuota i dati sono validi
  if (value === null || value === undefined) {
    return true;
  }
  // se non è una stringa non è un codice fiscale valido
  if (typeof (value) !== 'string') {
    return false;
  }
  let cf = value;
  let s;
  if (cf === '') {
    return true;
  }
  cf = cf.toUpperCase();
  if (cf.length !== 16) {
    return false;
  }
  const validi = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  for (let i = 0; i < 16; i += 1) {
    if (validi.indexOf(cf.charAt(i)) === -1) {
      return false;
    }
  }
  const set1 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const set2 = 'ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const setpari = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const setdisp = 'BAKPLCQDREVOSFTGUHMINJWZYX';
  s = 0;
  for (let i = 1; i <= 13; i += 2) {
    s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  }
  for (let i = 0; i <= 14; i += 2) {
    s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  }
  if (s % 26 !== cf.charCodeAt(15) - 'A'.charCodeAt(0)) {
    return false;
  }
  return true;
};

export const IBANValido = (iban) => {
  // se vuota i dati sono validi
  if (iban === null || iban === undefined) {
    return true;
  }
  // se non è una stringa non è un numero di cellualre valido
  if (typeof (iban) !== 'string') {
    return false;
  }
  if (iban.length === 0) {
    return true;
  }
  let newIban = iban.toUpperCase();
  if (newIban.length < 2 || newIban.substring(0, 2) !== 'IT') {
    return false;
  }
  const modulo = (divident, divisor) => {
    let m = 0;
    for (let i = 0; i < divident.length; i += 1) {
      m = (m * 10 + parseInt(divident.charAt(i), 10)) % divisor;
    }
    return m;
  };
  if (newIban.search(/^[A-Z]{2}/gi) < 0) {
    return false;
  }
  newIban = newIban.substring(4) + newIban.substring(0, 4);
  newIban = newIban.replace(/[A-Z]/g, (match) => match.charCodeAt(0) - 55);
  return parseInt(modulo(newIban, 97), 10) === 1;
};

function verificaCodiceProvinciaPartitaIva(partitaIva) {
  const codiceProvinciale = parseInt(partitaIva.substring(7, 10), 10);
  if ((codiceProvinciale === 0 || codiceProvinciale > 100)
    && codiceProvinciale !== 120
    && codiceProvinciale !== 121
    && codiceProvinciale !== 888
    && codiceProvinciale !== 999) {
    return false;
  }
  return true;
}

function verificaCodiceControlloPartitaIva(partitaIva) {
  // calcolo il codice di controllo
  let s = 0; let
    c = 0;
  for (let i = 0; i <= 9; i += 2) {
    s += partitaIva.charCodeAt(i) - '0'.charCodeAt(0);
  }
  for (let i = 1; i <= 9; i += 2) {
    c = 2 * (partitaIva.charCodeAt(i) - '0'.charCodeAt(0));
    if (c > 9) {
      c -= 9;
    }
    s += c;
  }
  // verifico che il codice di controllo sia corretto
  if ((10 - s % 10) % 10 !== partitaIva.charCodeAt(10) - '0'.charCodeAt(0)) {
    return false;
  }
  return true;
}

export const partitaIVAValida = (partitaIva) => {
  // se vuota i dati sono validi
  if (partitaIva === null || partitaIva === undefined) {
    return true;
  }
  // se non è una stringa non è una partita IVA valdia
  if (typeof (partitaIva) !== 'string') {
    return false;
  }
  if (partitaIva.length === 0) {
    return true;
  }
  // se la lunghezza non è corretta allora è sicuramente errata
  if (partitaIva.length !== 11) {
    return false;
  }
  // se sono presenti caratteri non numerici allora è errata
  const validi = '0123456789';
  for (let i = 0; i < 11; i += 1) {
    if (validi.indexOf(partitaIva.charAt(i)) === -1) {
      return false;
    }
  }

  if (
    !verificaCodiceProvinciaPartitaIva(partitaIva)
    || !verificaCodiceControlloPartitaIva(partitaIva)
  ) {
    return false;
  }

  return true;
};

export const telefonoValido = (telefono) => {
  // se vuota i dati sono validi
  if (telefono === null || telefono === undefined) {
    return true;
  }
  // se non è una stringa non è un numero di cellualre valido
  if (typeof (telefono) !== 'string') {
    return false;
  }
  if (telefono.length === 0) {
    return true;
  }
  if (telefono.replace(/ /g, '').match(/^[+]?[0|3]{1}[1-9]+[-\s/]?[0-9]{5,}$/i)) {
    return true;
  }
  return false;
};

export const mailValida = (mail) => {
  // se vuota i dati sono validi
  if (mail === null || mail === undefined) {
    return true;
  }
  // se non è una stringa non è un numero di cellualre valido
  if (typeof (mail) !== 'string') {
    return false;
  }
  if (mail.length === 0) {
    return true;
  }
  if (mail
    .replace(/ /g, '')
    .match(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])$/i)) {
    return true;
  }
  return false;
};

const ValidationRules = {
  required: 'required',
  minLength: 'minLength',
  maxLength: 'maxLength',
  CodiceFiscaleAlfaNumerico: 'CodiceFiscaleAlfaNumerico',
  PartitaIva: 'PartitaIva',
  CodiceFiscale: 'CodiceFiscale',
  IBAN: 'IBAN',
  Fax: 'Fax',
  Email: 'Email',
  Range: 'Range',
  Pattern: 'Pattern',
  Telefono: 'Telefono',
};

Validation.register(ValidationRules.required, (x, y) => !(`${x || ''}`).trim(), { message: 'Campo obbligatorio' });
Validation.register(ValidationRules.minLength, (x, y) => (y.minLength && (`${x}`).length < y.minLength), { message: 'Campo troppo corto' });
Validation.register(ValidationRules.maxLength, (x, y) => (y.maxLength && (`${x}`).length >= y.maxLength), { message: 'Campo troppo lungo' });
Validation.register(ValidationRules.CodiceFiscaleAlfaNumerico, (x, y) => !codiceFiscaleValido(`${x || ''}`), { message: 'Codice Fiscale non valido' });
Validation.register(ValidationRules.PartitaIva, (x, y) => !partitaIVAValida(x || ''), { message: 'Partita IVA non valida' });
Validation.register(ValidationRules.CodiceFiscale, (x, y) => !partitaIVAValida(`${x || ''}`) && !codiceFiscaleValido(`${x}`),
  { message: 'Codice Fiscale non valido' });
Validation.register(ValidationRules.IBAN, (x, y) => !IBANValido(`${x || ''}`), { message: 'IBAN non valido' });
Validation.register(ValidationRules.Telefono, (x, y) => !telefonoValido(`${x || ''}`), { message: 'Telefono non valido' });
Validation.register(ValidationRules.Fax, (x, y) => !telefonoValido(`${x || ''}`), { message: 'Fax non valido' });
Validation.register(ValidationRules.Email, (x, y) => !mailValida(`${x || ''}`), { message: 'Email non valida' });
Validation.register(ValidationRules.Range, (x, y) => {
  let val = null;
  if (x != null && x !== '') {
    val = parse(x);
  }
  return val < y.minValue || val > y.maxValue;
}, { message: "Valore non compreso nell'intervallo" });
Validation.register(ValidationRules.Pattern, (x, y) => !y.pattern.test(x), { message: 'Valore non corrispondente al pattern' });

Validation.DefaultRules = ValidationRules;
Validation.Levels = ValidationLevel;

export default Validation;
